export const RELATIVE_PATH = "";